export default {
  //处理日期
  vdateAdd(startDate) {
    startDate = new Date(startDate);
    startDate = +startDate + 1000 * 60 * 60;
    startDate = new Date(startDate);
    var nextStartDate =
      startDate.getFullYear() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getDate();
    return nextStartDate;
  },
};
